import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ResetCartFunnelBlockConfig } from '@front-platform/content-builder';
import { resetCartFunnelBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface ResetCartFunnelBlockRuntimeConfig {}

export type ResetCartFunnelBlockConfigInput = Partial<
  Omit<ResetCartFunnelBlockConfig, keyof ResetCartFunnelBlockRuntimeConfig> &
    ResetCartFunnelBlockRuntimeConfig
>;
export type ResetCartFunnelBlockResolvedConfig = Omit<
  ResetCartFunnelBlockConfig,
  keyof ResetCartFunnelBlockRuntimeConfig
> &
  Partial<ResetCartFunnelBlockRuntimeConfig>;
export interface ResetCartFunnelBlockContract extends ConfigComponentContract<
  ResetCartFunnelBlockConfigInput,
  ResetCartFunnelBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-reset-cart-funnel-block',
  standalone: false,
})
export class ResetCartFunnelBlockComponent implements OnInit, ResetCartFunnelBlockContract {
  readonly config = input<ResetCartFunnelBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ResetCartFunnelBlockConfig,
    ResetCartFunnelBlockRuntimeConfig
  >(resetCartFunnelBlockResolveConfig, () => ({ config: this.config() }));

  constructor(private cartFunnelDispatcher: CartFunnelStoreDispatcher) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.reset();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ResetCartFunnelBlockComponent, { 'keyAliases': {} });
